import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerCustomer } from "../../api";
import "./CreateCustomer.css";

const CreateCustomer = () => {
  const [customer, setCustomer] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomer({ ...customer, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await registerCustomer(customer);
      const customerId = response.data.id;
      navigate(`/admin/purchases/create/${customerId}`, {
        state: {
          successMessage: "Customer created successfully. Please add purchase.",
        },
      });
    } catch (error) {
      if (
        error.response &&
        error.response.data.error === "Customer already exists"
      ) {
        setErrorMessage("Customer already exists.");
      } else {
        setErrorMessage("An error occurred while creating the customer.");
      }
    }
  };

  return (
    <div className="create-customer-container">
      <form onSubmit={handleSubmit} className="create-customer-form">
        <h2>Create Customer</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            name="firstName"
            value={customer.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            name="lastName"
            value={customer.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={customer.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Phone No</label>
          <input
            type="text"
            name="phoneNo"
            value={customer.phoneNo}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
    </div>
  );
};

export default CreateCustomer;